import { Injectable } from "@angular/core";
import { IID_RISORSE_VERIFICA } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { RisorseVerificaStore } from "./risorseVerifica.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.IID_RISORSE_VERIFICA)
export class RisorseVerificaQuery extends AbstractInterfaceDataQuery<IID_RISORSE_VERIFICA> {
  constructor(protected store: RisorseVerificaStore) {
    super(store);
  }
}
